import { PersistedFormTokenChainState, UserState } from '../types/context';

// Reads the persisted chain from the blob's formTokens slice; null = no tokens
// persisted OR a structurally corrupt blob (treated as empty, never throws)
export const getPersistedFormTokenChain = (
  localStorageKey: string
): PersistedFormTokenChainState | null => {
  const storedItem = window.localStorage.getItem(localStorageKey);
  if (!storedItem) {
    return null;
  }

  let persistedState: Partial<UserState>;
  try {
    persistedState = JSON.parse(storedItem);
  } catch {
    return null;
  }

  const persistedChain = persistedState?.formTokens as
    | PersistedFormTokenChainState
    | undefined;
  if (
    !persistedChain ||
    !persistedChain.nodes ||
    typeof persistedChain.nodes !== 'object' ||
    !Array.isArray(persistedChain.roots) ||
    Object.keys(persistedChain.nodes).length === 0
  ) {
    return null;
  }

  const hasInvalidNode = Object.values(persistedChain.nodes).some(
    (node) => !node || typeof node !== 'object'
  );
  if (hasInvalidNode) {
    return null;
  }
  return persistedChain;
};
